import styled from "styled-components";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { Grid, Fab, TextField } from "@material-ui/core";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";

export const STModalWrapper = styled(Grid)`
&&&& {
  width: 620px;
}
`;

export const STWrapper = styled.div`
{
  min-height: 100px;
  padding: 0 10px 0 10px;
  width: 100%;
}
`;

export const CSTPaper = styled(STPaper)`
{
  margin-top: 20px;
  margin-bottom: 20px;
}
`;

export const CSFab = styled(Fab)`
&& {
  transform: scale(0.8);
}
`;

export const STEmptyAdd = styled.div`
{
  margin-top: 20px;
  margin-bottom: 20px;
}
`;

export const STEmptyAddWrapper = styled.div`
&& {
  float: right;
}
`;

export const SSTFormTitleTypography = styled(STFormTitleTypography)`
  &&& {
    margin-bottom: 25px;
    font-size: 18px;
  }
`;

export const ButtonsGrid = styled(Grid)`
  &&& {
    margin-top: 15px;
  }
`;

export const STTextField = styled(TextField)`
  &&& {
    margin-top: 10px;
  }
`;

export const STNote = styled.div`
  white-space: pre-line;
  padding: 7px 
  border: 1px solid #ddd;
`;